/* import __COLOCATED_TEMPLATE__ from './ach.hbs'; */
import { STRIPE_PAYMENT_INSTRUMENT_TYPE_ACH } from 'client-portal/utils/stripe-payment-instrument';
import { action } from '@ember/object';
import CheckoutInstrumentSection from './instrument-section';
import styles from './ach.module.scss';

export default class SiteBillingPaymentInstrumentPaymentModalCheckoutAch extends CheckoutInstrumentSection {
  styles = styles;

  get stripeAchBankAccounts() {
    return this.billingModals.client.stripeAchBankAccounts;
  }

  get hasSavedAchAccounts() {
    return this.stripeAchBankAccounts.length > 0;
  }

  get selectedAccount() {
    return this.selectedInstrument(STRIPE_PAYMENT_INSTRUMENT_TYPE_ACH);
  }

  @action
  addAch() {
    this.args.onAddAch(STRIPE_PAYMENT_INSTRUMENT_TYPE_ACH);
  }
}
